var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.text))]),_c('h3',[_vm._v("카카오 로그인 샘플")]),_c('button',{on:{"click":_vm.KakaoLogin}},[_vm._v("카카오 로그인")]),_c('button',{on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Close")])])
}
var staticRenderFns = []

export { render, staticRenderFns }